import { SYMBOL_SLUG_MAP } from "./symbol-name-map.generated";

export interface SymbolCategory {
  slug: string;
  name: string;
  emoji: string;
  description: string;
  tagline: string;
  symbols: string[];
}

export const categories: SymbolCategory[] = [
  {
    slug: "heart-symbols",
    name: "Heart Symbols",
    emoji: "♥",
    tagline: "Love, affection & every shade in between",
    description:
      "A curated collection of heart symbols — from classic hearts to ornate, decorative, and modern variants. Click any heart to copy it instantly.",
    symbols: ["♥","♡","❤","❣","❥","❦","❧","🧡","💛","💚","💙","💜","🖤","🤍","🤎","🩷","🩵","🩶","💕","💖","💗","💘","💝","💞","💟"],
  },
  {
    slug: "star-symbols",
    name: "Star Symbols",
    emoji: "★",
    tagline: "Sparkle, shine & celestial vibes",
    description:
      "Every kind of star symbol you could need — solid, outline, sparkles, asterisks and more. Perfect for ratings, bios and titles.",
    symbols: ["★","☆","✦","✧","✩","✪","✫","✬","✭","✮","✯","✰","⋆","✴","✵","✶","✷","✸","✹","✺","✻","✼","❅","❆","❉","❋","⭑","⭒","⚝","✢","✣","✤","✥","✽","❂","❃","❊","⁂","⁑","⭐","🌟","✨","💫","🌠"],
  },
  {
    slug: "arrow-symbols",
    name: "Arrow Symbols",
    emoji: "→",
    tagline: "Point, guide & direct attention",
    description:
      "Clean arrow symbols for every direction — minimal, bold, double, curved and decorative. Copy and use anywhere.",
    symbols: ["←","↑","→","↓","↖","↗","↘","↙","↔","↕","⇐","⇑","⇒","⇓","⇔","⇕","↞","↟","↠","↡","↢","↣","↤","↥","↦","↧","↩","↪","↫","↬","↭","↰","↱","↲","↳","↶","↷","↺","↻","⟲","⟳","⇄","⇅","⇆","⇇","⇈","⇉","⇊","⇚","⇛","⇠","⇡","⇢","⇣","⟵","⟶","⟷","➔","➜","➝","➞","➟","➠","➢","➣","➤","➥","➦","➨","➩","➫","➬","➭","➮","➯","➱","➲","➳","➵","➸","➻","➼","➽","➾"],
  },
  {
    slug: "check-cross-symbols",
    name: "Check and Cross Symbols",
    emoji: "✓",
    tagline: "Ticks, checkmarks, crosses & X marks",
    description:
      "Check marks and cross/X symbols for to-do lists, approvals, results and forms — ticks, ballot boxes and bold X marks, all ready to copy.",
    symbols: ["✓","✔","✅","☑","☐","⍻","✕","✖","✗","✘","☒","❌","❎","✚","✛","✜","☓","⮽"],
  },
  {
    slug: "math-symbols",
    name: "Math Symbols",
    emoji: "∑",
    tagline: "Equations, operators & logic",
    description:
      "Mathematical symbols including operators, set theory, logic, calculus and Greek letters used in math. Copy-ready for documents and notes.",
    symbols: ["+","−","×","÷","±","∓","=","≠","≈","≡","≤","≥","≪","≫","∞","∑","∏","∫","∮","∂","∇","√","∛","∜","∝","∠","∡","∢","⊥","∥","∈","∉","∋","⊂","⊃","⊆","⊇","∪","∩","∅","∀","∃","∄","¬","∧","∨","⊕","⊗","≅","≢","≮","≯","≲","≳","≺","≻","≼","≽","⊄","⊅","⊈","⊉","⋂","⋃","∖","∁","⊢","⊣","⊤","⊨","∴","∵","∎","∔","∘","⊖","⊘","⊙","⊞","⊟","⊠","⨁","⨂","∬","∭","∐","π","τ","φ","θ","λ","μ","σ","Σ","Δ","Ω"],
  },
  {
    slug: "currency-symbols",
    name: "Currency Symbols",
    emoji: "€",
    tagline: "Money symbols from around the world",
    description:
      "Currency symbols from every major economy — dollar, euro, pound, yen, rupee, won, ruble and more.",
    symbols: ["$","€","£","¥","₩","₹","₽","¢","₿","₣","₤","₥","₦","₧","₨","₪","₫","₭","₮","₯","₰","₱","₲","₳","₴","₵","₶","₷","₸","₺","₻","₼","₾","￠","￡","￥","￦","Ƀ","Ξ","₠","₡","₢","⃀"],
  },
  {
    slug: "number-symbols",
    name: "Number Symbols",
    emoji: "①",
    tagline: "Roman numerals, circled & enclosed digits",
    description:
      "Number-like Unicode symbols — upper- and lowercase Roman numerals plus circled, negative-circled, double-circled, parenthesized and full-stop digits. Click any to copy it instantly.",
    symbols: ["Ⅰ","Ⅱ","Ⅲ","Ⅳ","Ⅴ","Ⅵ","Ⅶ","Ⅷ","Ⅸ","Ⅹ","Ⅺ","Ⅻ","Ⅼ","Ⅽ","Ⅾ","Ⅿ","ⅰ","ⅱ","ⅲ","ⅳ","ⅴ","ⅵ","ⅶ","ⅷ","ⅸ","ⅹ","ⅺ","ⅻ","ⅼ","ⅽ","ⅾ","ⅿ","⓪","①","②","③","④","⑤","⑥","⑦","⑧","⑨","⑩","⑪","⑫","⑬","⑭","⑮","⑯","⑰","⑱","⑲","⑳","⓿","❶","❷","❸","❹","❺","❻","❼","❽","❾","❿","⓫","⓬","⓭","⓮","⓯","⓰","⓱","⓲","⓳","⓴","⓵","⓶","⓷","⓸","⓹","⓺","⓻","⓼","⓽","⓾","⑴","⑵","⑶","⑷","⑸","⑹","⑺","⑻","⑼","⑽","⑾","⑿","⒀","⒁","⒂","⒃","⒄","⒅","⒆","⒇","⒈","⒉","⒊","⒋","⒌","⒍","⒎","⒏","⒐","⒑","⒒","⒓","⒔","⒕","⒖","⒗","⒘","⒙","⒚","⒛"],
  },
  {
    slug: "punctuation-symbols",
    name: "Punctuation Symbols",
    emoji: "❡",
    tagline: "Marks, dashes & special punctuation",
    description:
      "Stylish punctuation marks, dashes, terminal points and special signs for titles, captions and design — beyond what a standard keyboard offers.",
    symbols: ["…","–","—","‐","‑","‒","―","·","‧","※","‼","⁇","⁈","⁉","‽","¶","§","¿","¡","✱","✲","✳","†","‡","‰","‱","‸","⸮","⸘","⁎"],
  },
  {
    slug: "geometric-shape-symbols",
    name: "Geometric Shape Symbols",
    emoji: "◆",
    tagline: "Diamonds, hexagons, pentagons, rectangles & more",
    description:
      "The broad geometric-shapes page — diamonds, hexagons, pentagons, rectangles and parallelograms in filled and outlined forms. For circles, squares and triangles, see their focused pages.",
    symbols: ["◆","◇","◈","◊","⬟","⬠","⬡","⬢","⬣","▬","▭","▮","▯","▰","▱"],
  },
  {
    slug: "circle-symbols",
    name: "Circle Symbols",
    emoji: "●",
    tagline: "Filled, outlined & half-shaded circles",
    description:
      "Circle symbols in every fill — solid, hollow, bullseye, dotted and half-shaded circles for diagrams, bullet lists, toggles and progress markers.",
    symbols: ["●","○","◉","◎","◌","◍","◐","◑","◒","◓","◔","◕","◖","◗","◙","◚","◛","◠","◡","◯","◴","◵","◶","◷"],
  },
  {
    slug: "square-symbols",
    name: "Square Symbols",
    emoji: "■",
    tagline: "Filled, outlined & patterned squares",
    description:
      "Square and rectangle symbols — solid, outlined, small and pattern-filled boxes useful for checklists, legends, UI mockups and ASCII-style layouts.",
    symbols: ["■","□","▢","▣","▤","▥","▦","▧","▨","▩","▪","▫","◧","◨","◩","◪","◫","◰","◱","◲","◳"],
  },
  {
    slug: "triangle-symbols",
    name: "Triangle Symbols",
    emoji: "▲",
    tagline: "Up, down & sideways triangles",
    description:
      "Triangle symbols pointing every direction — filled and outlined up, down, left and right triangles for play buttons, arrows, ratings and warnings.",
    symbols: ["△","▲","▽","▼","◁","◀","▷","▶","▴","▵","▸","▹","▾","▿","◂","◃","◢","◣","◤","◥","◸","◹","◺","◿","◬","◭","◮"],
  },
  {
    slug: "zodiac-symbols",
    name: "Zodiac Symbols",
    emoji: "♈",
    tagline: "The astrology star signs",
    description:
      "The thirteen zodiac signs — the classic twelve from Aries to Pisces plus Ophiuchus. Perfect for bios, charts and astrology content.",
    symbols: ["♈","♉","♊","♋","♌","♍","♎","♏","♐","♑","♒","♓","⛎"],
  },
  {
    slug: "chess-symbols",
    name: "Chess Symbols",
    emoji: "♛",
    tagline: "Black & white chess pieces",
    description:
      "Chess piece symbols in black and white — kings, queens, rooks, bishops, knights and pawns — for game writing, notation and design.",
    symbols: ["♔","♕","♖","♗","♘","♙","♚","♛","♜","♝","♞","♟"],
  },
  {
    slug: "music-symbols",
    name: "Music Symbols",
    emoji: "♫",
    tagline: "Notes, clefs & musical marks",
    description:
      "Musical notation symbols including notes, rests, clefs and dynamics. Great for music lovers and notation.",
    symbols: ["♩","♪","♫","♬","♭","♮","♯","𝄞","𝄢","𝄪","𝄫","𝄐","𝄑","𝄒","𝄓","𝄔","𝄕","𝄖","𝄗","𝄘","𝄙","𝄚","𝄛","𝄜","𝄝","𝄟","𝄠","𝄡","𝅗","𝅘","🎵","🎶","🎼","🎤","🎧","🎷","🎸","🎹","🎺","🎻","🥁"],
  },
  {
    slug: "weather-symbols",
    name: "Weather Symbols",
    emoji: "☀",
    tagline: "Sun, rain, snow & the elements",
    description:
      "Weather and seasonal symbols — sun, clouds, rain, snow, lightning and the elements — for forecasts, captions and nature-themed posts.",
    symbols: ["☀","☁","☂","☃","♨","❄","☔","☼","🌤","🌥","🌦","🌧","🌨","🌩","🌪","🌫","🌬","🌈","🌊","🔥","💧","⛅","⛈","⛄","🌞","🌝","🌙"],
  },
  {
    slug: "technical-symbols",
    name: "Technical Symbols",
    emoji: "⌬",
    tagline: "Power, controls & interface glyphs",
    description:
      "Technical and interface glyphs — power, eject, recycle, gear and other control-style marks used across software, hardware labels and UI.",
    symbols: ["⌽","⌚","⌖","⌗","⌬","⏻","⏼","⏽","⭘","⏾","⚙","⚛","♻","✉","✎","✏","✐","✒","⌧","⏰","☎","✆","✇","⌂","⌛","⌕","⌲","⎈","⎌","⎓","⎙","⏣","⏱","⏳","⏺"],
  },
  {
    slug: "keyboard-symbols",
    name: "Keyboard Symbols",
    emoji: "⌘",
    tagline: "Command, option, shift & the keys",
    description:
      "Keyboard key symbols — command, option, shift, control, escape, return, delete, tab and caps — for shortcut documentation, cheat sheets and tutorials.",
    symbols: ["⌘","⌥","⇧","⌃","⎋","⏎","⌫","⌦","⇪","⇥","⇤","⏏","⌨","⎇","␣","⎆","⎀","⎚"],
  },
  {
    slug: "bullet-symbols",
    name: "Bullet Symbols",
    emoji: "•",
    tagline: "List markers & inline separators",
    description:
      "Bullet and list-marker symbols — round bullets, triangular bullets, hyphen bullets and middle dots — for plain-text lists, bios and inline separators.",
    symbols: ["•","‣","⁃","⁌","⁍","◦","◘","∙","⦾","⦿","⁕","⁘","⁙","⁛","☙","⸰"],
  },
  {
    slug: "line-symbols",
    name: "Line Symbols",
    emoji: "―",
    tagline: "Rules, bars, blocks & shades",
    description:
      "Text-friendly line symbols — horizontal rules, vertical bars, overlines, underlines and wavy dividers, plus the block-element bars, shades and quadrants used for ASCII art and progress bars. Click to copy any line.",
    symbols: ["‾","¯","‗","⎯","⎺","⎻","⎼","⎽","▔","▁","﹉","﹊","﹋","﹌","﹍","﹎","﹏","＿","￣","|","¦","‖","⏐","｜","￤","／","＼","⁓","〜","〰","⸺","⸻","▀","▂","▃","▄","▅","▆","▇","█","▉","▊","▋","▌","▍","▎","▏","▐","░","▒","▓","▕","▖","▗","▘","▙","▚","▛","▜","▝","▞","▟"],
  },
  {
    slug: "bracket-symbols",
    name: "Bracket Symbols",
    emoji: "❲",
    tagline: "Parentheses, braces, square & angle brackets",
    // NOTE: this array contains a literal ASCII "]" element. build-data.mjs and
    // validate.mjs capture the whole single-line symbols array ([^\n], not
    // [^\]]), so an internal "]" does not terminate the parse early.
    description:
      "Bracket symbols — round parentheses, square and curly braces, angle brackets, ceiling and floor, plus fullwidth, ornamental and lenticular variants for code, math and titles. Click to copy.",
    symbols: ["(",")","（","）","❨","❩","[","]","［","］","⟦","⟧","{","}","｛","｝","❴","❵","⟨","⟩","⟪","⟫","《","》","⌈","⌉","⌊","⌋","【","】","〈","〉","⁅","⁆","⦃","⦄","〚","〛","〖","〗","〘","〙","〔","〕","❬","❭","❰","❱","⦇","⦈","｢","｣","⌜","⌝","⌞","⌟"],
  },
  {
    slug: "quote-symbols",
    name: "Quote Symbols",
    emoji: "“",
    tagline: "Curly quotes, guillemets, primes & corner brackets",
    description:
      "Quotation mark symbols — straight and curly single and double quotes, guillemets, prime marks and CJK corner brackets for dialogue, citations and typographic detail. Click to copy.",
    symbols: ["\"","'","‘","’","‚","‛","“","”","„","‟","«","»","‹","›","′","″","‴","‵","「","」","『","』","❝","❞"],
  },
  {
    slug: "superscript-subscript-symbols",
    name: "Superscript and Subscript Symbols",
    emoji: "²",
    tagline: "Raised & lowered digits, signs and math notation",
    description:
      "Superscript and subscript symbols — raised and lowered digits plus the plus, minus, equals and parenthesis signs for exponents, footnotes, chemical formulas and math notation. Click to copy.",
    symbols: ["⁰","¹","²","³","⁴","⁵","⁶","⁷","⁸","⁹","ⁱ","ⁿ","⁺","⁻","⁼","⁽","⁾","₀","₁","₂","₃","₄","₅","₆","₇","₈","₉","₊","₋","₌","₍","₎","ₐ","ₑ","ₒ","ₓ","ₔ","ₕ","ₖ","ₗ","ₘ","ₙ","ₚ","ₛ","ₜ"],
  },
  {
    slug: "fraction-symbols",
    name: "Fraction Symbols",
    emoji: "½",
    tagline: "Halves, thirds, quarters & vulgar fractions",
    description:
      "Fraction symbols — ready-made vulgar fractions like halves, thirds, quarters, fifths and eighths, plus the fraction slash for composing your own. Click to copy.",
    symbols: ["½","⅓","⅔","¼","¾","⅕","⅖","⅗","⅘","⅙","⅚","⅛","⅜","⅝","⅞","⅐","⅑","⅒","⁄","⅟"],
  },
  {
    slug: "box-drawing-symbols",
    name: "Box Drawing Symbols",
    emoji: "╬",
    tagline: "Lines, corners & junctions for boxes",
    description:
      "Box-drawing symbols — light, heavy and double lines, corners, T-junctions, crosses, rounded corners and diagonals for tables, frames and terminal-style ASCII art. Click to copy.",
    symbols: ["─","│","┌","┐","└","┘","├","┤","┬","┴","┼","━","┃","┏","┓","┗","┛","┣","┫","┳","┻","╋","═","║","╔","╗","╚","╝","╠","╣","╦","╩","╬","╭","╮","╯","╰","╱","╲","╳"],
  },
  {
    slug: "planet-symbols",
    name: "Planet Symbols",
    emoji: "♄",
    tagline: "Sun, moon, planets & celestial bodies",
    description:
      "Planet and celestial-body symbols — the Sun, Moon phases, the classical planets, dwarf planets and asteroids, plus a comet and the lunar nodes. Click to copy.",
    symbols: ["☉","☽","☾","☿","♁","♃","♄","♅","♆","♇","⛢","☄","⚳","⚴","⚵","⚶","⚷","⚸","☊","☋"],
  },
  {
    slug: "card-dice-symbols",
    name: "Card and Dice Symbols",
    emoji: "🎲",
    tagline: "Full 52-card deck, suits & dice faces",
    description:
      "Card and dice symbols — playing card suits, aces, jokers and face cards plus the six dice faces. Click to copy for games, tabletop and design.",
    symbols: ["⚀","⚁","⚂","⚃","⚄","⚅","♠","♤","♦","♢","♣","♧","🂡","🂢","🂣","🂤","🂥","🂦","🂧","🂨","🂩","🂪","🂫","🂭","🂮","🂱","🂲","🂳","🂴","🂵","🂶","🂷","🂸","🂹","🂺","🂻","🂽","🂾","🃁","🃂","🃃","🃄","🃅","🃆","🃇","🃈","🃉","🃊","🃋","🃍","🃎","🃑","🃒","🃓","🃔","🃕","🃖","🃗","🃘","🃙","🃚","🃛","🃝","🃞","🂠","🂿","🃏","🃟"],
  },
  {
    slug: "warning-symbols",
    name: "Warning Symbols",
    emoji: "⚠",
    tagline: "Hazard, caution & prohibition signs",
    description:
      "Warning and hazard symbols — caution, radioactive, biohazard, skull and crossbones, no-entry, high voltage and other safety and prohibition signs. Click to copy.",
    symbols: ["⚠","☢","☣","☠","☡","⛔","⚡","⌁","⏚","⏛","🚫","🛑","⛑","🔞","🆘","🚸","🚷","🚭","🚳","🚱","📵","🚯"],
  },
  {
    slug: "medical-symbols",
    name: "Medical Symbols",
    emoji: "⚕",
    tagline: "Health, care & clinical symbols",
    description:
      "Medical symbols — the staff of Aesculapius, caduceus and staff of Hermes plus pills, syringe, stethoscope, bandage and other health and clinical icons. Click to copy.",
    symbols: ["⚕","☤","⚚","💊","💉","🩺","🩹","🩼","🩻","🏥","🩸","🫀","🫁","🧬","🦠","🧪","🧫","🌡","🦽","🦼"],
  },
  {
    slug: "nature-symbols",
    name: "Nature Symbols",
    emoji: "🌿",
    tagline: "Trees, plants, earth & landscapes",
    description:
      "Nature symbols — trees, leaves, plants, crops, mushrooms, mountains, rocks and earth globes for nature, eco and outdoor themes. Click any to copy. For creatures, see the Animal Symbols page.",
    symbols: ["🌲","🌳","🌴","🌵","🌱","🌿","☘","🍀","🍃","🍂","🍁","🪴","🌾","🌰","🍄","🪵","🪨","🌍","🌎","🌏","🌋","⛰","🏔","🗻","🪺"],
  },
  {
    slug: "animal-symbols",
    name: "Animal Symbols",
    emoji: "🐾",
    tagline: "Mammals, birds, sea life, reptiles & bugs",
    description:
      "Animal emoji to copy and paste — mammals, birds, sea creatures, reptiles, amphibians, bugs and a few mythical beasts. Click any animal to copy it instantly.",
    symbols: ["🐵","🐒","🦍","🦧","🐶","🐕","🦮","🐩","🐺","🦊","🦝","🐱","🐈","🦁","🐯","🐅","🐆","🐴","🫎","🐎","🦄","🦓","🦌","🦬","🐮","🐂","🐃","🐄","🐷","🐖","🐗","🐽","🐏","🐑","🐐","🐪","🐫","🦙","🦒","🐘","🦣","🦏","🦛","🐭","🐁","🐀","🐹","🐰","🐇","🐿","🦫","🦔","🦇","🐻","🐨","🐼","🦥","🦦","🦨","🦘","🦡","🐾","🦃","🐔","🐓","🐣","🐤","🐥","🐦","🐧","🕊","🦅","🦆","🦢","🦉","🦤","🪶","🦩","🦚","🦜","🪽","🪿","🐸","🐊","🐢","🦎","🐍","🐲","🐉","🦕","🦖","🐳","🦈","🐬","🦭","🐟","🐠","🐡","🪸","🐙","🐚","🪼","🐌","🦋","🐛","🐜","🐝","🪲","🐞","🦗","🪳","🕷","🕸","🦂","🦟","🪰"],
  },
  {
    slug: "flower-symbols",
    name: "Flower Symbols",
    emoji: "🌸",
    tagline: "Blossoms, bouquets & florettes",
    description:
      "Flower symbols — cherry blossom, hibiscus, sunflower, tulip and rose plus bouquet, lotus, rosette and decorative florettes. Click to copy for spring, floral and aesthetic posts.",
    symbols: ["🌸","🌺","🌻","🌷","🌹","🌼","💐","🏵","🪷","🥀","⚘","❀","✿","❁","💮","🪻","✾","⚜"],
  },
  {
    slug: "religious-symbols",
    name: "Religious Symbols",
    emoji: "✝",
    tagline: "Faith, cross & spiritual symbols",
    description:
      "Religious and spiritual symbols — crosses, the star of David, star and crescent, om, wheel of dharma, yin yang, ankh and places of worship. Click to copy.",
    symbols: ["✝","✞","✟","☦","☧","☨","☩","✠","✡","☪","☬","☸","☯","☮","☥","🕉","🔯","⛤","⛪","🕌","🕍","🛕","🕋","📿","♰","♱","☫","🕎","⛨"],
  },
  {
    slug: "gender-symbols",
    name: "Gender Symbols",
    emoji: "⚥",
    tagline: "Sex, gender & relationship signs",
    description:
      "Gender and sex symbols — the female and male signs plus transgender, doubled, interlocked and neuter variants, the marriage and divorce signs and restroom symbols. Click to copy.",
    symbols: ["♀","♂","⚢","⚣","⚤","⚥","⚦","⚧","⚨","⚩","⚲","⚭","⚮","⚯","🚹","🚺","🚻","🚼"],
  },
  {
    slug: "office-copyright-trademark-symbols",
    name: "Office, Copyright and Trademark Symbols",
    emoji: "©",
    tagline: "Copyright, trademark & office marks",
    description:
      "Office, copyright and trademark symbols — the copyright, registered and trademark marks plus service mark, numero, paperclips, folders, charts, rulers and other workplace icons. Click to copy.",
    symbols: ["©","®","™","℠","℗","№","℅","📎","📌","📍","📋","📁","📂","📅","📈","📉","📊","💼","📐","📏","✂","📝","🖨","🖇"],
  },
  {
    slug: "transport-map-symbols",
    name: "Transport and Map Symbols",
    emoji: "🚗",
    tagline: "Cars, trains, planes, ships & maps",
    description:
      "Transport and map symbols — cars, buses, trains, planes, ships and bikes plus maps, compass, roads, traffic lights and travel icons. Click to copy.",
    symbols: ["🚗","🚕","🚌","🚑","🚒","🚓","🚚","🚜","🏍","🚲","🚂","🚆","🚄","🚇","🚊","✈","🚁","🚀","🛸","⛵","⛴","🚢","⚓","🗺","🧭","🛣","🛤","🚦","⛽","🚧","🚙","🚐","🚛","🛻","🏎","🚝","🚞","🚋","🚉","🛺","🛵","🚏"],
  },
  {
    slug: "people-hands",
    name: "People & Hands",
    emoji: "👋",
    tagline: "Hands, faces & gestures with skin-tone support",
    description:
      "Hand gestures, body parts and people emoji — every entry that accepts a Fitzpatrick skin-tone modifier is rendered in all five tones with one-click copy.",
    symbols: ["👋","✋","🤚","🖐","🖖","👌","🤌","🤏","✌","🤞","🤟","🤘","🤙","👈","👉","👆","🖕","👇","☝","👍","👎","✊","👊","🤛","🤜","👏","🙌","👐","🤲","🤝","🙏","✍","💅","🤳","💪","🦵","🦶","👂","🦻","👃","👶","🧒","👦","👧","🧑","👱","👨","🧔","👩","🧓","👴","👵"],
  },
];

/** Parent/child relationships (taxonomy contract). Maps child slug → parent slug. */
export const CATEGORY_PARENTS: Record<string, string> = {
  "circle-symbols": "geometric-shape-symbols",
  "square-symbols": "geometric-shape-symbols",
  "triangle-symbols": "geometric-shape-symbols",
};

/**
 * Slugs that were renamed during the v2 taxonomy convergence. Old URL → new URL.
 * `categories.$slug` issues a permanent redirect for these so previously-indexed
 * `/categories/<old>/` URLs resolve to the canonical `-symbols` route.
 */
export const CATEGORY_SLUG_REDIRECTS: Record<string, string> = {
  hearts: "heart-symbols",
  stars: "star-symbols",
  arrows: "arrow-symbols",
  math: "math-symbols",
  currency: "currency-symbols",
  punctuation: "punctuation-symbols",
  shapes: "geometric-shape-symbols",
  zodiac: "zodiac-symbols",
  chess: "chess-symbols",
  music: "music-symbols",
  weather: "weather-symbols",
  tech: "technical-symbols",
};


export function getCategory(slug: string) {
  return categories.find((c) => c.slug === slug);
}

export interface SymbolEntry {
  symbol: string;
  slug: string;
  categorySlug: string;
  categoryName: string;
}

function codepointsHex(s: string): string {
  return Array.from(s)
    .map((c) => c.codePointAt(0)!.toString(16))
    .join("-");
}

// Returns the canonical, human-readable slug for a symbol (e.g. "black-star").
// Uses the lightweight char->slug map so client code doesn't pull the full index.
// Index-backed resolvers (allSymbols, findSymbolBySlug, getSiblingNav, lookalikes,
// block neighbors, …) live in server-only `symbol-resolve.ts`.
export function symbolSlug(s: string): string {
  return SYMBOL_SLUG_MAP[s] ?? `symbol-${codepointsHex(s)}`;
}
